// extracted by mini-css-extract-plugin
module.exports = {"item":"SuggestedKeywordList_item__Fibpw","keywords":"SuggestedKeywordList_keywords__OzNRH"};